import styles from './Loader.module.scss';
import Card from '../Card/Card';
import { FC } from 'react';

type TLoaderProps = {
    size?: number;
    label?: string;
};

type TCardLoaderProps = {
    addTopPadding?: boolean;
    label?: string;
};

export const Loader: FC<TLoaderProps> = (props) => {
    const { size, label } = props;
    return (
        <>
            <div
                className={styles.loader}
                style={size ? { height: `${size}px`, width: `${size}px` } : undefined}
                data-testid="loader"
            >
                <div />
                <div />
                <div />
                <div />
            </div>
            {label && <div className={styles.label}>{label}</div>}
        </>
    );
};

const CardLoader: FC<TCardLoaderProps> = (props) => {
    const { addTopPadding = false, label } = props;
    return (
        <div className={`${addTopPadding && styles.addTopPadding}`}>
            <Card>
                <section className={styles.container}>
                    <Loader label={label} />
                </section>
            </Card>
        </div>
    );
};

export default CardLoader;
